import { gql } from '@urql/core'

export const queryProjectBudgetByProjectBase = gql`
  query FetchProjectBudget($projectBaseQuery: project_base_bool_exp) {
    project_base(where: $projectBaseQuery) {
      id
      project_budget {
        id
        gfch_share_budget
        share_responsible_organization_budget
        other_funding_budget
        gfch_share_approved
        share_responsible_organization_approved
        other_funding_approved
        version
      }
      pf_kap_projects {
        application_type {
          code
        }
      }
    }
  }
`

export const queryFinancialsForAllYearsGivenProject = gql`
  query queryFinancialsForYearsAllGivenProject($projectBaseWhere: project_base_bool_exp!) {
    project_base(where: $projectBaseWhere) {
      project_budget {
        gfch_share_approved
        share_responsible_organization_approved
        other_funding_approved
      }
    }
    milestone(
      where: { _and: { type: { _eq: "FINANCIAL_REPORT" }, dossier: { project_bases: $projectBaseWhere } } }
      order_by: [{ due_date: asc }, { year_in_focus: asc }, { type: asc }]
    ) {
      id
      year_in_focus
      project_financial_report {
        id
        gfch_share_annual_value
        share_responsible_organization_annual_value
        other_funding_annual_value
      }
    }
  }
`

export const updateProjectBudget = gql`
  mutation ($projectBudget: [project_budget_insert_input!]!, $updateColumns: [project_budget_update_column!]!) {
    insert_project_budget(
      objects: $projectBudget
      on_conflict: { constraint: project_budget_project_base_id_uq, update_columns: $updateColumns }
    ) {
      affected_rows
      returning {
        version
      }
    }
  }
`
